import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PackageTable } from "./packages/package-table";
import { SeriesTable } from "./series/series-table";
import useDocumentTitle from "@/components/ui/common/document-title";
import { Dumbbell, Users } from "lucide-react";

const TrainingManagement: React.FC = () => {
  useDocumentTitle("Training Management");
  const location = useLocation();
  const navigate = useNavigate();

  const getInitialTab = () => {
    if (location.pathname.includes("class")) return "series";
    return "packages";
  };

  const [activeTab, setActiveTab] = useState(getInitialTab);

  useEffect(() => {
    if (location.pathname.includes("class")) {
      setActiveTab("series");
    } else if (location.pathname.includes("package")) {
      setActiveTab("packages");
    }
  }, [location.pathname]);

  const handleTabChange = (val: string) => {
    setActiveTab(val);
    if (val === "series") {
      navigate("/admin/training-class");
    } else {
      navigate("/admin/training-package");
    }
  };

  return (
    <div className="w-full p-5 space-y-4">
      <Tabs value={activeTab} onValueChange={handleTabChange} className="w-full space-y-4">
        <TabsList className="grid w-full sm:w-fit grid-cols-2 mb-2">
          <TabsTrigger value="packages" className="gap-2">
            <Dumbbell className="size-4" />
            Training Packages
          </TabsTrigger>
          <TabsTrigger value="series" className="gap-2">
            <Users className="size-4" />
            Member Subscriptions & Classes
          </TabsTrigger>
        </TabsList>

        <TabsContent value="packages" className="space-y-4">
          <Card className="pt-4 pb-2">
            <PackageTable />
          </Card>
        </TabsContent>

        <TabsContent value="series" className="space-y-4">
          <Card className="pt-4 pb-2">
            <SeriesTable />
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default TrainingManagement;